import AbstractViewManage from '@/class/view/AbstractViewManage'
import ChargeGroupCounter from './ChargeGroupCounter'
import ChargeCountField from './ChargeCountField'
import ChargeCountDataAdapte from './ChargeCountDataAdapte'
import ChargeCountManager from './ChargeCountManager'
import lang from '@/lang'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { formatNumberToThousands } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'
import BigNumber from 'bignumber.js'

export default class ChargeCountGroupHP extends AbstractViewManage {
  constructor(view) {
    super(view)
    this._dispCountedState = 0
  }

  /**
   * 重新计算- 原始数据源发生变化时，需触发重新计算
   */
  recalc() {
    this.groupingCalc()
  }

  // 分币种列表显示
  currencyType() {
    return ([
      new ChargeCountField(lang.t('Billing.billingView_receivables'),
        'chargeAmountTotal', 'chargeCurrency', null, ChargeCountManager.DISP_IN_GRID, [
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true)
        ]),
      new ChargeCountField(lang.t('Billing.billingView_payables'),
        'chargeAmountTotal', 'chargeCurrency', null, ChargeCountManager.DISP_IN_GRID, [
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
        ]),
      new ChargeCountField(lang.t('Billing.billingView_total'), 'chargeAmountTotal', 'chargeCurrency', null, ChargeCountManager.DISP_IN_GRID, [
        new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
        new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
      ]),
      new ChargeCountField(lang.t('Invoice.invoice_convert'),
        'amount', 'currency', null, ChargeCountManager.DISP_IN_GROUP, [
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
        ])
    ])
  }

  // 分币种列表显示(仅用于付款申请)
  currencyTypeNew(isR = false) {
    const list = ([
      new ChargeCountField(lang.t('Billing.billingView_receivables'),
        'charge_amount', 'charge_currency', null, ChargeCountManager.DISP_IN_GRID, [
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'charge_receivable', ChargeGroupCounter.OPERATOR_EQUAL, true)
        ]),
      new ChargeCountField(lang.t('Billing.billingView_payables'),
        'charge_amount', 'charge_currency', null, ChargeCountManager.DISP_IN_GRID, [
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'charge_receivable', ChargeGroupCounter.OPERATOR_EQUAL, false)
        ])
    ])
    if (isR) {
      list.push(new ChargeCountField(lang.t('Billing.billingView_total'), 'charge_amount', 'charge_currency', null, ChargeCountManager.DISP_IN_GRID, [
        new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'charge_receivable', ChargeGroupCounter.OPERATOR_EQUAL, true),
        new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'charge_receivable', ChargeGroupCounter.OPERATOR_EQUAL, false)
      ]))
      list.push(new ChargeCountField(lang.t('Invoice.invoice_convert'),
        'amount', 'currency', null, ChargeCountManager.DISP_IN_GROUP, ([
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'charge_receivable', ChargeGroupCounter.OPERATOR_EQUAL, true),
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'charge_receivable', ChargeGroupCounter.OPERATOR_EQUAL, false)
        ])))
    } else {
      list.push(new ChargeCountField(lang.t('Billing.billingView_total'), 'charge_amount', 'charge_currency', null, ChargeCountManager.DISP_IN_GRID, [
        new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'charge_receivable', ChargeGroupCounter.OPERATOR_EQUAL, true),
        new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'charge_receivable', ChargeGroupCounter.OPERATOR_EQUAL, false)
      ]))
    }
    return list
  }

  groupingCalc() {
    let result = {}
    // if (this._view.currentState === ChargeCountManager.STATE_HIDE) {
    //   this._dispCountedState++
    // }
    if (this._view.newByJob > 0) {
      if (this._view.newByJob === 4) {
        result = ChargeGroupCounter.groupingCalcNew(this.invoices(), this.invoiceCurrencyType(), this._view.currentState === ChargeCountManager.STATE_DISP)
      } else {
        result = ChargeGroupCounter.groupingCalcByJob(this._view.dataProvider, this.currencyTypeNew(this._view.showRmb), this._view.currentState === ChargeCountManager.STATE_DISP, this._view.dataField)
      }
    } else if (this._view.newCurrencyCode) {
      result = ChargeGroupCounter.groupingCalcNew(this._view.dataProvider, this.currencyType(), this._view.currentState === ChargeCountManager.STATE_DISP)
    } else {
      result = ChargeGroupCounter.groupingCalc(this._view.dataProvider, this._view.displayAndCountFieldList, this._view.basicCurrency, this._view.currentState === ChargeCountManager.STATE_DISP, this._view.source)
    }
    this._view.chargeCountGridResultList = result['chargeCountGridResultList']
    const columns = result['chargeCountWindowColumns']
    if (columns && columns.length > 0) {
      this.toSetColumnDefs(columns)
      this._view.rowData = this._view.chargeCountGridResultList
    } else {
      this._view.columnDefs = []
      this._view.rowData = []
    }
    if (this._view.source === 'invoiceQueryList' && this._view.chargeTotalData && this._view.chargeTotalData.length > 0) {
      this.mergeChargeTotalColumns()
    }
    // 折合 数据源
    this._view.exchangeAmount.dataProvider = result['chargeCountGroupResultList']
    if (!this._view.showRmb) {
      this._view.lbSize.text = this._view.selectedCount === 0 ? '' : (lang.t('Message.Choose') + this._view.selectedCount + lang.t('Message.Updated2'))
    } else {
      this._view.lbSize.text = ''
    }
  }

  toSetColumnDefs(columns) {
    const columnDefs = columns.map(item => {
      return {
        headerName: item === 'RMB' ? 'RMB(折合)' : item,
        field: item,
        valueFormatter: (params) => {
          return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 2, '0.00'))
        },
        width: 80
      }
    })
    columnDefs.unshift({ headerName: this._view.$t('Billing.billingCharge_currency'),
      field: 'dispName',
      width: 130 })
    this._view.columnDefs = columnDefs
  }
  mergeChargeTotalColumns() {
    const chargeTotalData = this._view.chargeTotalData || []
    const displayFields = this._view.displayAndCountFieldList
    const dispToCountField = {}
    displayFields.forEach(field => {
      if (field.inGrid && field.fieldName) {
        dispToCountField[field.fieldName] = field.countField
      }
    })
    const existingColumnDefs = this._view.columnDefs
    const existingFields = new Set(existingColumnDefs.map(col => col.field))
    const fixedCurrencies = ['RMB', 'USD', 'VND', 'EUR', 'KZT']
    const chargeTotalMap = {}
    chargeTotalData.forEach(ct => {
      chargeTotalMap[ct.currency] = ct
    })
    const rmbIndex = existingColumnDefs.findIndex(col => col.field === 'RMB')
    const insertIndex = rmbIndex >= 0 ? rmbIndex + 1 : existingColumnDefs.length
    fixedCurrencies.forEach((currency, offset) => {
      const fieldName = 'chargeTotal_' + currency
      if (!existingFields.has(fieldName)) {
        existingColumnDefs.splice(insertIndex + offset, 0, {
          headerName: currency,
          field: fieldName,
          valueFormatter: (params) => {
            return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 2, '0.00'))
          },
          width: 80
        })
        existingFields.add(fieldName)
      }
    })
    const rowData = this._view.chargeCountGridResultList
    rowData.forEach(row => {
      const countField = dispToCountField[row.dispName] || row.dispName
      fixedCurrencies.forEach(currency => {
        const fieldName = 'chargeTotal_' + currency
        const ct = chargeTotalMap[currency]
        row[fieldName] = ct ? (ct[countField] !== undefined ? ct[countField] : 0) : 0
      })
    })
    this._view.rowData = rowData
  }
  /**
   * 点击事件响应
   * @param event
   */
  clickHandler(event) {
    this.dispOrHideWindow()
    //
    if (event) { // 按钮触发
      const item = {}
      item.hidePop = this._view.currentState === ChargeCountManager.STATE_HIDE
      LocalStorageUtils.setConfiguration(this.getConfigByNewJob(), item)
    }
    //
    if (!this._view.alwaysShow) {
      // 隐藏窗口
      this._view.$emit('hidePop', this._view.currentState !== ChargeCountManager.STATE_HIDE)
    }
  }

  getConfigByNewJob() {
    let s = 'chargeCountGroup_hidePop'
    if (this._view.newByJob === 1) {
      s = 'jobCountGroup_hidePop'
    } else if (this._view.newByJob === 2) {
      s = 'chargeCountGroup_hidePop'
    } else if (this._view.newByJob === 3) {
      s = 'financeCountGroup_hidePop'
    }
    return s
  }

  /**
   * 显示或者隐藏窗体
   */
  dispOrHideWindow() {
    if (this._view.currentState === ChargeCountManager.STATE_HIDE) {
      this._view.closedState = 1
      this._view.currentState = ChargeCountManager.STATE_DISP
      this.groupingCalc()
    } else {
      this._view.closedState = 2
      this._view.currentState = ChargeCountManager.STATE_HIDE
    }
  }

  /**
   * 添加至布局时根据状态弹出窗体
   * @param event
   */
  addToStageHandler(event) {
    // _chargeCountGroupView = this;
    // if (_chargeCountGridResultList == null || _chargeCountGridResultList.length == 0)
    //   updateDefault_chargeCountGridResultList();
    // changeCurrentCountGroup();
    // groupingCalc();
  }

  creationCompleteHandler(event) {
    // _chargeCountGroupView = this;
    // if (_chargeCountGridResultList == null || _chargeCountGridResultList.length == 0)
    //   updateDefault_chargeCountGridResultList();
    // changeCurrentCountGroup();
    // groupingCalc();
  }

  // 初始化 表格数据
  updateDefault_chargeCountGridResultList() {
    // _chargeCountGridResultList = new ArrayCollection();
    // for each(var field:ChargeCountField in _displayAndCountFieldList) {
    //   if (field.inGrid) {
    //     _chargeCountGridResultList.push({"dispName": field.fieldName, "RMB": 0});
    //   }
    // }
  }

  /**
   *
   */
  commitProperties() {
    this.groupingCalc()
    // 记住用户上一次的操作
    const item = LocalStorageUtils.getConfiguration(this.getConfigByNewJob())
    if (item) {
      this.clickHandler(null)
      if (item.hidePop) { // 隐藏
        if (this._view.currentState === ChargeCountManager.STATE_DISP) {
          this.clickHandler(null)
        }
      } else {
        if (this._view.currentState === ChargeCountManager.STATE_HIDE) {
          this.clickHandler(null)
        }
      }
    }
  }

  /**
   * 自动弹出功能，调用位置：用户点击搜索后的场景 // todo-shengsheng  Desc: 自动弹出 控制逻辑待转换处理
   * 以下条件符合时执行
   * 当用户没有手动点击过当前页面的详情弹出功能
   */
  popWindowAuto() {
    //     if (visible && _closedState == 0 && currentState == ChargeCountManager.STATE_HIDE) {
    //       createPoint();
    //       if (currentState == ChargeCountManager.STATE_HIDE) {
    // //                    currentState = ChargeCountManager.STATE_DISP;
    //         changeCurrentCountGroup();
    //         groupingCalc();
    //         // CARGO-287，首次进入未销账列表，右下角默认展开，建议改为默认关闭
    // //                    popWindow();
    //         if (_dataProvider && _dataProvider.length > 0) {
    //           popWindow();
    //         }
    //       }
    //     }
  }

  // 分币种列表显示(未销账列表-按发票查询模式)
  invoiceCurrencyType() {
    return ([
      new ChargeCountField(lang.t('CargoMsg.UnverifiedAmountForCharge'),
        'totalUnverifiedAmount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
        ]),
      new ChargeCountField(lang.t('CargoMsg.VerifiedAmountForCharge'),
        'totalVerifiedAmount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
        ]),
      new ChargeCountField(lang.t('CargoMsg.ReceivableForCharge'),
        'totalAmount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true)
        ]),
      new ChargeCountField(lang.t('CargoMsg.PayableForCharge'),
        'totalAmount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
        ]),
      new ChargeCountField(lang.t('Billing.billingView_total'), 'totalAmount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
        new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
        new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
      ]),
      new ChargeCountField(lang.t('Invoice.invoice_convert'),
        'totalAmount', 'currency', null, ChargeCountManager.DISP_IN_GROUP, [
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
          new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
        ])
    ])
  }

  // 分币种列表显示(未销账列表-按发票查询模式) - 重新组装数据源
  invoices() {
    const list = []
    if (this._view.dataProvider && this._view.dataProvider.length > 0) {
      for (const item of this._view.dataProvider) {
        const currencyAmount = item.currencyAmount // 分币种合计
        const isAr = item.isAr
        if (currencyAmount) {
          const arr = currencyAmount.split(' ')
          if (arr && arr.length > 0) {
            for (const o of arr) {
              if (o) {
                const currencyArray = o.split(':')
                if (currencyArray && currencyArray.length === 2) {
                  const currency = currencyArray[0]
                  if (currency) {
                    const amount = isNaN(currencyArray[1]) ? new BigNumber(0) : new BigNumber(currencyArray[1]) // 金额
                    const index = list.findIndex(p => p.currency === currency && p.isAr === isAr)
                    if (index < 0) {
                      const rowData = {
                        'isAr': isAr,
                        'currency': currency,
                        'totalAmount': amount.toNumber(),
                        'totalUnverifiedAmount': new BigNumber(0).toNumber(), // 初始化未核销金额
                        'totalVerifiedAmount': new BigNumber(0).toNumber() // 初始化核销金额
                      }
                      list.push(rowData)
                    } else {
                      const row = list.find(p => p.currency === currency && p.isAr === isAr)
                      if (row) {
                        row.totalAmount = new BigNumber(row.totalAmount).plus(new BigNumber(amount)).toNumber()
                      }
                    }
                  }
                }
              }
            }
          }
        }
        const unverifiedAmountStr = item.unverifiedAmountStr // 未核销金额分币种合计
        if (unverifiedAmountStr) {
          const unverifiedAmountArr = unverifiedAmountStr.split(' ')
          if (unverifiedAmountArr && unverifiedAmountArr.length > 0) {
            for (const u of unverifiedAmountArr) {
              if (u) {
                const unVerifiedCurrencyArray = u.split(':')
                if (unVerifiedCurrencyArray && unVerifiedCurrencyArray.length === 2) {
                  const unVerifiedCurrency = unVerifiedCurrencyArray[0]
                  if (unVerifiedCurrency) {
                    const unVerifiedAmount = isNaN(unVerifiedCurrencyArray[1]) ? new BigNumber(0) : new BigNumber(unVerifiedCurrencyArray[1]) // 未核销金额
                    const row = list.find(p => p.currency === unVerifiedCurrency && p.isAr === isAr)
                    if (row) {
                      row.totalUnverifiedAmount = new BigNumber(row.totalUnverifiedAmount).plus(new BigNumber(unVerifiedAmount)).toNumber()
                      row.totalVerifiedAmount = new BigNumber(row.totalAmount).minus(new BigNumber(row.totalUnverifiedAmount)).toNumber()
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return list
  }
}
